
import { whatsapp } from "@/app/infrastructures/misc/Utils";
import { cleanPhoneNumber } from "@/app/infrastructures/misc/common-library/Whatsapp";
import { prop, Vue } from "vue-class-component";

class Props {
  isClaim = prop<boolean>({
    default: false,
    type: Boolean
  });
  csInfoPopup = prop<boolean>({
    default: false,
    type: Boolean
  });
  sttNo = prop<string>({
    default: "",
    type: String
  });
}

export default class CsInfo extends Vue.with(Props) {
  callPhoneNumber = "+62-21-80820072";
  waPhoneNumber = "+62811-1956-1000";
  onClickWhatsapp() {
    whatsapp(this.waPhoneNumber);
  }

  get formatCallPhoneNumber() {
    return cleanPhoneNumber(this.callPhoneNumber);
  }
}
